import $ from 'jquery';

/* global x5script */

class ContactForm {
  constructor() {
    this.form = $('.gform_wrapper');

    this.formPardotConfirmation();
    this.formHiddenContent();

    if (!this.form.length) {
      return;
    }

    $(document).on('gform_post_render', () => {
      $(
        '.gform_wrapper.gform_validation_error .gform_body ul li.gfield.gfield_error:not(.gf_left_half):not(.gf_right_half)',
      ).each((i, el) => {
        $(el)[0].style.setProperty('max-width', '100%', 'important');
      });

      const choiceLabelHide = $('.gf_choice_label_hide');

      if (choiceLabelHide.length) {
        $.each(choiceLabelHide, (i, el) => {
          const label = $(el).find(
            '.gfield_radio label, .gfield_checkbox label, .gfield_consent_label',
          );

          if (label.parent().prop('tagName') !== 'SPAN') {
            label.wrapInner('<span></span>');
          }
        });
      }
    });
  }

  formPardotConfirmation() {
    $(window).on('load', () => {
      this.pardotConfirmation = $('.js-form-pardot-confirmation').first();
      const courseQuestionFormTab = $('.js-questions-form-header');

      if (this.pardotConfirmation.length) {
        if (courseQuestionFormTab.length) {
          courseQuestionFormTab.trigger('click');
        }

        $('body, html')
          .stop()
          .animate(
            {
              scrollTop: this.pardotConfirmation.offset().top - 100,
            },
            100,
            () => {
              window.history.replaceState(null, null, window.location.pathname);
            },
          );
      }
    });
  }

  formHiddenContent() {
    this.hcForm = $('.js-fhc-form');

    if (!this.hcForm.length) {
      return;
    }

    const formId = this.hcForm.data('hcf-id');
    const postId = this.hcForm.data('hcp-id');
    const contentWrapper = this.hcForm.siblings('.js-fhc-form-content');
    const loader = this.hcForm.parent().find('.js-loader');

    $(document).on('gform_confirmation_loaded', (event, fid) => {
      if (formId === fid) {
        loader.show();

        const formWrapper = this.hcForm.find('.gform_confirmation_wrapper');
        formWrapper.hide();

        const data = {
          action: 'load_hcp_content',
          postid: postId,
          security: x5script.security,
        };

        $.post(x5script.ajaxurl, data, response => {
          if (response.error) {
            contentWrapper.html(
              `<h4 class="fhc-form-content-error">${response.error}</h4>`,
            );
          } else if (response.ok) {
            contentWrapper.html(response.content);
          }

          contentWrapper.stop().animate({ opacity: 1 }, 300);
          loader.hide();
        });
      }
    });
  }
}

export default new ContactForm();



// WEBPACK FOOTER //
// ./src/scripts/modules/contact-form.js